module.exports = __webpack_public_path__ + "img/jcb-logo.61e942fc.png";